// extracted by mini-css-extract-plugin
export var section = "connect-module--section--3FG0q";
export var inner = "connect-module--inner--2AfIr";
export var content = "connect-module--content--1s136";
export var title = "connect-module--title--1QUKO";